export default [
    {
        header: 'Mensagens',
        icon: 'MailIcon',
        children: [
            {
                title: 'Enviar Mensagem',
                route: 'enviar-mensagem',
                icon: 'SendIcon',
                permissao: 1
            },
            {
                title: 'Modelos (template)',
                route: 'modelo-mensagem',
                icon: 'MailIcon',
                permissao: 1
            },
            {
                title: 'Logs Mensagens Automáticas',
                route: 'logs-mensagem',
                icon: 'ListIcon',
                permissao: 1
            },
        ],
    },
]
